// Consistent date + time display for customer-facing surfaces.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function to12h(timeStr) {
  if (!timeStr) return "";
  const [h, m] = timeStr.split(":");
  let hr = parseInt(h, 10);
  const ampm = hr >= 12 ? "PM" : "AM";
  hr = hr % 12 || 12;
  return `${hr}:${(m || "00").padStart(2, "0")} ${ampm}`;
}

// travel date (YYYY-MM-DD) + optional time (HH:MM) → "05 Jul 2026, 9:30 AM"
export function formatDateTime(dateStr, timeStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr + (timeStr ? `T${timeStr}` : "T00:00"));
  if (isNaN(d)) return `${dateStr}${timeStr ? " · " + to12h(timeStr) : ""}`;
  const base = `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  return timeStr ? `${base}, ${to12h(timeStr)}` : base;
}

// ISO timestamp → "05 Jul 2026, 9:30 AM"
export function formatTimestamp(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  let hr = d.getHours();
  const ampm = hr >= 12 ? "PM" : "AM";
  hr = hr % 12 || 12;
  const mins = String(d.getMinutes()).padStart(2, "0");
  return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${hr}:${mins} ${ampm}`;
}
